export const cashFlowSelectors = {
  gridData: (state) => state.gridData,
  item: (state) => state.item,
  update: (state) => state.update,
}
